import { UUID } from 'v2/core/entities/uuid';
import { QBNode } from 'v2/querybuilder/types/qbNode';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

export function denormaliseQuery(
  nodes: Record<UUID, NormalisedNode>,
  rootUUID: UUID,
): QBNode {
  const root = nodes[rootUUID];

  if (root.type === 'filter') {
    return root;
  }

  const children = root.children
    .map((id) => denormaliseQuery(nodes, id))
    .filter((filter) => {
      return filter.type === 'filter' ? !!filter.field : true;
    });

  return {
    ...root,
    children,
  };
}
